import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { SUMMARY_BASE_PATH } from '../constants/summaryBasePath';

export const postSummaryExport = async (
  constructPost: ConstructPost,
  definitionName: string,
  uuid?: string,
  identifier?: string,
  data?: any,
): Promise<NonPaginatedResponse<any[]> | undefined> =>
  constructPost(
    `${SUMMARY_BASE_PATH}/${uuid}/export/${identifier}`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
